// extracted by mini-css-extract-plugin
module.exports = {"content":"TripCartDrawer_content__vzR9l","fade-in":"TripCartDrawer_fade-in__zPa2D"};